import { render, staticRenderFns } from "./NextList.vue?vue&type=template&id=5881fa0c&scoped=true&"
import script from "./NextList.vue?vue&type=script&lang=js&"
export * from "./NextList.vue?vue&type=script&lang=js&"
import style0 from "./NextList.vue?vue&type=style&index=0&id=5881fa0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5881fa0c",
  null
  
)

export default component.exports